/* eslint-disable func-names */
import _ from 'lodash';

Mobi2Go._class = Mobi2Go._class || {};

const { Price } = Mobi2Go._class.Common;

const OrderProductSizeModifier = function(menu_modifier, parent_product) {
    if (!(this instanceof OrderProductSizeModifier)) {
        return new OrderProductSizeModifier(menu_modifier, parent_product);
    }

    this.menu_modifier = menu_modifier;
    this.parent_product = parent_product;
    this.id = null;

    this.price = new Price(menu_modifier.price);

    this.updateRestriction();

    Mobi2Go.Order.bind({
        updateMenuRestrictions: () => this.updateRestriction(),
    });
};

OrderProductSizeModifier.prototype.toString = function() {
    return this.menu_modifier.name;
};

OrderProductSizeModifier.prototype.match = function(comparator) {
    return _.isObject(comparator)
        ? comparator.menu_modifier.id === this.menu_modifier.id
        : this.id === +comparator || this.name === comparator;
};

OrderProductSizeModifier.prototype.setId = function(id) {
    this.id = id;
};

OrderProductSizeModifier.prototype.toJson = function() {
    return {
        id: this.id,
        menu_modifier: _.pick(this.menu_modifier, ['id', 'name']),
    };
};

OrderProductSizeModifier.prototype.getPrice = function() {
    return this.menu_modifier.getPrice();
};

OrderProductSizeModifier.prototype.getTotal = function() {
    return this.menu_modifier.getPrice();
};

OrderProductSizeModifier.prototype.getDisplayPrice = function() {
    return this.parent_product.menu_product.getPrice().add(this.getPrice());
};

OrderProductSizeModifier.prototype.updateRestriction = function() {
    this.updateVisibility();
    this.updateSoldOut();
};

OrderProductSizeModifier.prototype.updateVisibility = function() {
    const new_visible = !Mobi2Go.Order.isModifierHidden(this.menu_modifier);
    if (new_visible !== this.visible) {
        this.visible = new_visible;
        this.parent_product._triggerUpdateModifierVisiblity(this);
    }
};

OrderProductSizeModifier.prototype.updateSoldOut = function() {
    const new_out_of_stock = Mobi2Go.Order.isModifierSoldOut(
        this.menu_modifier
    );
    if (new_out_of_stock !== this.out_of_stock) {
        this.out_of_stock = new_out_of_stock;
        this.parent_product._triggerUpdateModifierOutOfStock(this);
    }
};

Mobi2Go._class.OrderProductSizeModifier = OrderProductSizeModifier;
